define('editor/edit/layers/add/kml/index',['durandal/app', 'plugins/http', 'knockout', 'knockout-mapping', 'jquery', 'leaflet-omnivore', 'dropzone'], function (app, http, ko, komapping, $, omnivore) {
    var viewmodel = function() {
        var self = this;

        self.rawKml = ko.observable();
        self.layersToAdd = ko.observableArray([]);

        self.activate = function(mapId, cancelFunc) {
            self.mapId = mapId;
            self.exit = function () {
                if (self.layersToAdd().length) {
                    app.map.removeLayers(self.layersToAdd());
                }
                cancelFunc();
            };
        };

        self.compositionComplete = function () {
            Dropzone.autoDiscover = false;
            self.kmlUpload = new Dropzone("#file-drop", {
                acceptedFiles: ".kml,.kmz",
                maxFilesize: 2,
                dictDefaultMessage: '<span class="glyphicon glyphicon-open"></span> Click here or drop a .kml or .kmz file (Max 500KB) and only polygons are supported at this time.'
            });
            self.kmlUpload.on("complete", function(file) {
                self.kmlUpload.removeFile(file);
            });
            self.kmlUpload.on("success", function(file, response) {
                if (response.success) {
                    self.rawKml(response.data.kml);
                    var layer = omnivore.kml.parse(response.data.kml);
                    var shapeLayers = layer.getLayers();
                    for (var i = 0; i < shapeLayers.length ; i++) {
                        if (shapeLayers[i].feature.geometry.type !== 'Polygon') {
                            layer.removeLayer(shapeLayers[i]);
                        }
                    }
                    if (layer.getLayers().length < 1) {
                        app.showMessage('No polygons found in the uploaded file');
                    } else {
                        self.layersToAdd.push(layer);
                        layer.addTo(app.map.map);
                    }
                }
            });
        };
        
        self.save = function () {
            if (self.layersToAdd().length) {
                var json = self.layersToAdd()[0].toGeoJSON();
                var data = self.buildFeatureCollectionPostBody(json);
                self.saveGroupedLayers(data)
                    .then(function() {
                        app.trigger('layers:available');
                        self.exit();
                    })
                    .fail(app.showError);
            } else {
                self.exit();
            }
        };

        self.buildFeatureCollectionPostBody = function (featureCollection) {
            var collectionLen = featureCollection.features.length,
                feature,
                dto = {
                    editorMapId: self.mapId,
                    layers: []
                };

            for (var i = 0; i < collectionLen; i++) {
                feature = featureCollection.features[i];
                
                self.addFeatureStyleProperties(feature);
                
                dto.layers.push({
                    name: feature.properties.name || '',
                    type: 'GeoJSON',
                    state: feature
                });
            }

            return dto;
        };

        self.addFeatureStyleProperties = function (feature) {
            var shapeOptions = { // from L.Draw.Polygon.options.shapeOptions
                stroke: true,
                color: '#0000ff',
                weight: 2,
                opacity: 0.5,
                fill: true,
                fillColor: null, //same as color by default
                fillOpacity: 0.2,
                clickable: true
            };

            feature.properties = feature.properties || {};
            
            $.extend(feature.properties, shapeOptions);
        };
        
        self.saveGroupedLayers = function (data) {
            var url = "/api/editor/layers/addmulti";

            return http.post(url, data);
        };
    };

    return viewmodel;
});

